
import { defineComponent, ref, onMounted } from 'vue'
import ListContentLayout from '@/views/layout/ListContentLayout.vue'
import { repositories } from '@/repositories/system/repositories'
import { User } from '@/repositories/data'
import { Company } from '@/repositories/system/data'
import UserUpdateDialog from '@/views/system/UserUpdateDialog.vue'
import ConfirmDeleteModal from '@/views/modal/ConfirmDeleteModal.vue'
import { callApiWrapper } from '@/views/callApiWrapper'
import { useRoute } from 'vue-router'
import ConfirmSendWelcomeMail from '@/views/system/ConfirmSendWelcomeMail.vue'
import ConfirmSendWelcomeMailAllUser from '@/views/system/ConfirmSendWelcomeMailAllUser.vue'

const companyRepository = repositories.company
const userRepository = repositories.user

export default defineComponent({
  components: {
    ConfirmSendWelcomeMailAllUser,
    ConfirmSendWelcomeMail,
    ConfirmDeleteModal,
    UserUpdateDialog,
    ListContentLayout
  },
  setup () {
    const route = useRoute()
    const users = ref<User[]>([])
    const requestError = ref<string | null>(null)
    const showingAddModal = ref<boolean>(false)
    const company = ref<Company>({
      key: 'dummy',
      name: '',
      isAvailable: true
    })
    const mailTargetUser = ref<User | null>(null)
    const showingSendAllUser = ref(false)
    const modifyTargetUser = ref<User | null>(null)
    const deleteTargetUser = ref<User | null>(null)

    onMounted(async () => {
      const companyKey = route.params.companyKey as string
      await callApiWrapper(requestError, async () => {
        company.value = await companyRepository.get(companyKey)
        users.value = await userRepository.list(companyKey)
      })
    })

    const onUpdated = async () => {
      const companyKey = route.params.companyKey as string
      showingAddModal.value = false
      await callApiWrapper(requestError, async () => {
        users.value = await userRepository.list(companyKey)
        modifyTargetUser.value = null
      })
    }

    const deleteUser = async (target: User) => {
      const companyKey = route.params.companyKey as string
      await callApiWrapper(requestError, async () => {
        await userRepository.delete(companyKey, target.key)
        deleteTargetUser.value = null
        users.value = await userRepository.list(companyKey)
      })
    }

    const updateList = async () => {
      const companyKey = route.params.companyKey as string
      await callApiWrapper(requestError, async () => {
        users.value = await userRepository.list(companyKey)
      })
    }

    return {
      users,
      company,
      showingAddModal,
      modifyTargetUser,
      deleteTargetUser,
      requestError,
      mailTargetUser,
      showingSendAllUser,
      onUpdated,
      deleteUser,
      updateList
    }
  }
})
